import React, { Component } from 'react'
import styles from '../components/styles.css'
import { MIME_TYPES, captureThumb } from '../helper'
import { FaPlayCircle, FaStopCircle } from 'react-icons/fa'

class Recorder extends Component {
    constructor(props) {
        super(props)

        this.cameraVideo = React.createRef()
        this.state = {
            isRecording: false,
            chunkSize: 10,
            isCameraOn: false,
            stream: undefined,
            duration: props.countDown
        }
    }



    componentWillUnmount = () => {
        this.turnOffCamera()
    }

    turnOnCamera = () => {
        if (navigator.mediaDevices) {
            navigator.mediaDevices
                .getUserMedia(this.props.constraints)
                .then(this.handleSuccess)
                .catch(this.handleError)
        } else {
            alert('Camera not supported by browser')
        }
    }

    turnOffCamera = () => {
        const { cameraStateChange, countDown } = this.props
        this.stream && this.stream.getTracks().forEach(stream => stream.stop())
        this.setState({
            isCameraOn: false,
            duration: countDown
        })
        cameraStateChange(false)
        clearInterval(this.durationTimer)
        clearInterval(this.autoStopTimer)
    }

    handleSuccess = stream => {
        this.stream = stream
        this.setState({
            isCameraOn: true,
            stream: stream
        })
        this.props.cameraStateChange(true)
        if (window.URL) {
            this.cameraVideo.srcObject = stream
        } else {
            this.cameraVideo.src = stream
        }

        // there is probably a better way
        // but this makes sure the start recording button
        // gives the stream a couple miliseconds to be ready
        setTimeout(() => {
            this.setState({
                isConnecting: false,
                streamIsReady: true
            })
        }, 200)
    }

    handleError = err => {
        if (this.state.isCameraOn) {
            this.turnOffCamera()
        }
    }

    startRecording = () => {
        captureThumb(this.cameraVideo).then(thumbnail => {
            this.thumbnail = thumbnail

            this.recordedBlobs = []
            const options = {
                mimeType: this.getMimeType()
            }

            try {
                this.setState({
                    isRecording: true
                })
                this.startedAt = new Date().getTime()
                this.durationTimer = setInterval(() => this.setState({ duration: this.state.duration - 1 }), 1000)
                this.mediaRecorder = new window.MediaRecorder(this.stream, options)
                this.mediaRecorder.addEventListener('stop', this.handleStop)
                this.mediaRecorder.addEventListener('error', this.handleError)
                this.mediaRecorder.addEventListener(
                    'dataavailable',
                    this.handleDataAvailable
                )

                const { chunkSize } = this.state
                this.mediaRecorder.start(chunkSize) // collect 10ms of data

                // if (timeLimit) {
                //     this.timeLimitTimeout = setTimeout(() => {
                //         this.handleStopRecording()
                //     }, timeLimit)
                // }

                // // mediaRecorder.ondataavailable should be called every 10ms,
                // // as that's what we're passing to mediaRecorder.start() above
                // if (Number.isInteger(dataAvailableTimeout)) {
                //     setTimeout(() => {
                //         if (this.recordedBlobs.length === 0) {
                //             this.handleError(
                //                 new ReactVideoRecorderDataAvailableTimeoutError(
                //                     dataAvailableTimeout
                //                 )
                //             )
                //         }
                //     }, dataAvailableTimeout)
                // }
            } catch (err) {
                console.error("Couldn't create MediaRecorder", err, options)
                this.handleError(err)
            }
        })
    }

    getMimeType = () => {
        return window.MediaRecorder.isTypeSupported(MIME_TYPES.MP4) ? MIME_TYPES.MP4 : MIME_TYPES.WEBM
    }

    handleDataAvailable = event => {
        if (this.isDataHealthOK(event)) {
            this.recordedBlobs.push(event.data)
        }
    }

    isDataHealthOK = event => {
        // // need to handle this
        // if (!event.data) return this.handleDataIssue(event)

        const { chunkSize } = this.state

        const dataCheckInterval = 2000 / chunkSize

        // in some browsers (FF/S), data only shows up
        // after a certain amount of time ~everyt 2 seconds
        const blobCount = this.recordedBlobs.length
        if (blobCount > dataCheckInterval && blobCount % dataCheckInterval === 0) {
            const blob = new window.Blob(this.recordedBlobs, {
                type: this.getMimeType()
            })
            // if (blob.size <= 0) return this.handleDataIssue(event)
        }

        return true
    }

    handleStop = event => {
        const endedAt = new Date().getTime()

        const videoBlob =
            this.recordedBlobs.length === 1
                ? this.recordedBlobs[0]
                : new window.Blob(this.recordedBlobs, {
                    type: this.getMimeType()
                })

        const thumbnailBlob = this.thumbnail
        const startedAt = this.startedAt
        const duration = endedAt - startedAt

        // if this gets executed too soon, the last chunk of data is lost on FF
        this.mediaRecorder.ondataavailable = null

        this.setState({
            isRecording: false,
            videoBlob,
            videoUrl: window.URL.createObjectURL(videoBlob)
        })

        this.turnOffCamera()

        this.props.onRecordingComplete({
            videoBlob,
            videoUrl: window.URL.createObjectURL(videoBlob),
            startedAt,
            thumbnailBlob,
            duration
        })
    }

    handlePauseRecording = () => {
        this.mediaRecorder.pause()
    }

    handleStopRecording = () => {
        this.mediaRecorder.stop()
    }

    handleResumeRecording = () => {
        this.mediaRecorder.resume()
    }

    handleStartRecording = () => {
        this.startRecording()
        this.autoStopTimer = setTimeout(() => {
            this.handleStopRecording();
        }, this.props.countDown * 1000);
    }

    uploadToS3 = (videoBlob, startedAt, thumbnailBlob, duration) => {
        var config = {
            signerUrl: '',
            aws_key: '',
            bucket: '',
            cloudfront: true,
            computeContentMd5: true,
            cryptoMd5Method: function (data) { return crypto.createHash('md5').update(data).digest('base64'); }
        };

        return Evaporate.create(config)
            .then(function (evaporate) {

                var file = new File([""], "file_object_to_upload"),
                    addConfig = {
                        name: file.name,
                        file: file,
                        progress: function (progressValue) { console.log('Progress', progressValue); },
                        complete: function (_xhr, awsKey) { console.log('Complete!'); },
                    },
                    overrides = {
                        bucket: AWS_BUCKET // Shows that the bucket can be changed per
                    };
                evaporate.add(addConfig, overrides)
                    .then(function (awsObjectKey) {
                        console.log('File successfully uploaded to:', awsObjectKey);
                    },
                        function (reason) {
                            console.log('File did not upload sucessfully:', reason);
                        });
            });
    }

    render() {
        const { isCameraOn, isRecording, duration } = this.state
        const { content, frame, frameHeight } = this.props
        return (
            <div>
                {
                    isCameraOn ?
                        <video
                            className={styles.video}
                            ref={el => (this.cameraVideo = el)}
                            autoPlay
                            muted
                            playsInline
                        /> :
                        null
                }
                {
                    isCameraOn ?
                        <div className={styles.overlay}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: '100%', height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <h1 style={{ color: '#fff', height: '100%' }}>{duration} <small>sec</small></h1>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ width: '100%', height: frameHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <img src={frame} />
                                    </div>
                                </div>
                            </div>
                            {isRecording ?
                                <div className={styles.captureButtonWrapper} onClick={this.handleStopRecording}>
                                    <FaStopCircle color={'#fff'} size={60} />
                                </div> :
                                <div className={styles.captureButtonWrapper} onClick={this.handleStartRecording}>
                                    <FaPlayCircle color={'#fff'} size={60} />
                                </div>}
                        </div>
                        : null
                }
                {/* <img ref={el => (this.cameraImage = el)} className={styles.image}/> */}
                <div style={{ width: '100%' }} onClick={this.turnOnCamera}>
                    {content}
                </div>
            </div>
        )
    }
}

export default Recorder
